import checkInview from "../../../utils/check-inview";
import getLocalTrigger from "../../../utils/get-local-trigger";
import viewportenter from "../events/viewport-enter";
import viewportleave from "../events/viewport-leave";

/**
 * Run inview triggers
 * @param {Number} windowHeight
 * @param {Number} scrollX
 * @param {Number} scrollY
 */
const initInview = (windowHeight, scrollX, scrollY) => {
  const viewports = /** @type {GlobalSingleTriggerProps} */ (
    getLocalTrigger("viewport")
  );

  if (!viewports || !viewports.size) {
    return;
  }

  for (const [main, names] of viewports) {
    let bounds = /** @type {BoundsProps} */ (main["tor-bounds"] || main.bounds);

    for (const name of names) {
      const trigger = /** @type {TriggerProps} */ (main.store.get(name));

      const pTarget = /** @type {TriggerParameterTypeProps} */ (
        trigger.get("p_target")
      );
      const pKeep = /** @type {TriggerParameterTypeProps} */ (
        trigger.get("p_keep")
      );

      const target = /** @type {Array<TorusElement>} */ (
        /** @type {unknown} */ (pTarget.get("value"))
      );
      const keep = /** @type {Boolean} */ (
        /** @type {unknown} */ (pKeep.get("value"))
      );

      const enterIsActive = trigger.get("enter-is-active");
      const leaveIsActive = trigger.get("leave-is-active");

      if (target) {
        bounds = /** @type {BoundsProps} */ (target[0]["tor-bounds"]);
      }

      if (keep && enterIsActive) {
        continue;
      }

      const isInview = checkInview(
        bounds,
        trigger,
        windowHeight,
        scrollX,
        scrollY
      );

      if (isInview && !enterIsActive) {
        viewportenter(main.events.get(`viewportenter:${name}`));
        trigger.set("enter-is-active", true);
        trigger.set("leave-is-active", false);
      }
      if (!isInview && !leaveIsActive) {
        viewportleave(main.events.get(`viewportleave:${name}`));
        trigger.set("leave-is-active", true);
        trigger.set("enter-is-active", false);
      }
    }
  }
};

export default initInview;
